// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badges_badge__WzXIy","radio":"Badges_radio__FrhMq","quickSearchIcon":"Badges_quickSearchIcon__mb8a5","fmgIcon":"Badges_fmgIcon__lSCUT"};